export const LikeIcon = ({ isLiked }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 mr-1"
      fill={isLiked ? "#3b82f6" : "none"} // Blue when liked
      viewBox="0 0 24 24"
      stroke={isLiked ? "#3b82f6" : "currentColor"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
      />
    </svg>
  );
};

export const UpvoteIcon = ({ isUpvoted }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4"
      fill={isUpvoted ? "currentColor" : "none"} // Blue when upvoted
      viewBox="0 0 24 24"
      stroke={isUpvoted ? "CurrentColor" : "currentColor"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 4l-8 8h5v8h6v-8h5l-8-8z"
      />
    </svg>
  );
};

export const DownvoteIcon = ({ isDownvoted }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 "
      fill={isDownvoted ? "currentColor" : "none"} // Red when downvoted
      viewBox="0 0 24 24"
      stroke={isDownvoted ? "currentColor" : "currentColor"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 20l-8-8h5V4h6v8h5l-8 8z"
      />
    </svg>
  );
};

export const ReloadIcon = ({ }) => {
  return (
    <svg className="" fill="white" stroke="white" height="20" viewBox="0 0 48 48" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M35.3 12.7c-2.89-2.9-6.88-4.7-11.3-4.7-8.84 0-15.98 7.16-15.98 16s7.14 16 15.98 16c7.45 0 13.69-5.1 15.46-12h-4.16c-1.65 4.66-6.07 8-11.3 8-6.63 0-12-5.37-12-12s5.37-12 12-12c3.31 0 6.28 1.38 8.45 3.55l-6.45 6.45h14v-14l-4.7 4.7z"></path></svg>
  )
}


export const DeleteIcon = ({ isHovered, size = "6" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`h-${size} w-${size}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke={isHovered ? "#ef4444" : "currentColor"} // Red when hovered
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  );
};

export const DisLikeIcon = ({ isDisliked }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 mr-1"
      fill={isDisliked ? "#ef4444" : "none"} // Red when disliked
      viewBox="0 0 24 24"
      stroke={isDisliked ? "#ef4444" : "currentColor"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018c.163 0 .326.02.485.06L17 4m-7 5v5a2 2 0 002 2h.095c.5 0 .905-.405.905-.905 0-.714.211-1.412.608-2.006L17 13V4m-7 5h2m5 0v2a2 2 0 01-2 2h-2.5"
      />
    </svg>
  );
};

export const ReplyIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 mr-1 flex items-center justify-content animate-pop"
      fill="none"
      viewBox="0 0 24 24"
      stroke={isActive ? "#10b981" : "currentColor"} // Green when active
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
      />
    </svg>
  );
};

export const BackArrow = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke={isActive ? "#3b82f6" : "currentColor"} // Blue when active
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      />
    </svg>
  );
};

export const SearchIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192.904 192.904"
      width="20px"
      className={isActive ? "fill-blue-500" : "fill-gray-500"}
    >
      <path d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z"></path>
    </svg>
  );
};

// export const heartSvg = (filled = false) => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" id="heart">
//       <path
//         fill={filled ? "#ff4d4d" : "none"} // Red when filled
//         fillRule="evenodd"
//         stroke={filled ? "#ff4d4d" : "currentColor"}
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth="2"
//         d="M20.84 2.61a5.5 5.5 0 0 0-7.78 0L12 3.67l-1.06-1.06a5.501 5.501 0 0 0-7.78 7.78l1.06 1.06L12 19.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
//       ></path>
//     </svg>
//   );
// };

export const LeftIcon = () => {
  return (
    <svg
      height={15}
      width={15}
      stroke="currentColor"
      fill="currentColor"
      viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
      ></path>
    </svg>
  )
}

export const RightArrowIcon = () => {
  return (
    <svg
      height={15}
      width={15}
      stroke="currentColor"
      fill="currentColor"
      className="rotate-180"
      viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
      ></path>
    </svg>
  )
}

export const CommentIcon = ({ h = 5, w = 5, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="rgba(0,0,0,0.6)"          // default light mode stroke
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
      className={`h-${h} w-${w} transition-all duration-300 dark:stroke-low_text`}
      {...props}
    >
      <path d="M21 6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11l4 4V6z" />
    </svg>
  );
};




export const heartSvg = (filled) => (
  <svg
    viewBox="0 0 24 24"
    fill={filled ? "#ff4757" : "none"} // red fill if liked
    stroke={filled ? "#ff4757" : "white"} // use currentColor so Tailwind text classes apply
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`
      transition-all duration-300 
      ${filled ? "scale-110" : "scale-100"} 
      h-5 w-5 md:h-6 md:w-6
      ${!filled ? "text-gray-600 dark:text-gray-300" : ""} 
    `}
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);




export const Sparkle = ({ style, color }) => (
  <div
    className="absolute pointer-events-none animate-ping"
    style={style}
  >
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill={color}
      className="animate-spin"
    >
      <path d="M12 0l2.4 7.2L24 12l-9.6 4.8L12 24l-2.4-7.2L0 12l9.6-4.8z" />
    </svg>
  </div>
);

export const thumbsDownSvg = (filled = false) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={filled ? "#ef4444" : "currentColor"} // Red when filled
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.095c.5 0 .905-.405.905-.905 0-.714.211-1.412.608-2.006L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
        fill={filled ? "#ef4444" : "none"}
      ></path>
    </svg>
  );
};

export const AttachIcon = ({ isActive, height = 5, smHeight = 4 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`h-${smHeight} w-${smHeight} sm:h-${height} sm:w-${height} mr-1 cursor-pointer`}
    fill="none"
    viewBox="0 0 24 24"
    stroke={isActive ? "#8b5cf6" : "currentColor"} // Purple when active
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
    />
  </svg>
);

export const AiResponseIcon = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-1"
    fill="none"
    viewBox="0 0 24 24"
    stroke={isActive ? "#f59e0b" : "currentColor"} // Amber when active
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 10V3L4 14h7v7l9-11h-7z"
    />
  </svg>
);

export const GenerateIcon = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-1"
    fill="none"
    viewBox="0 0 24 24"
    stroke={isActive ? "#06b6d4" : "currentColor"} // Cyan when active
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

export const SparklesIcon = ({ size = 24, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="#FFD700"
      width={size}
      height={size}
      className={className}
    >
      {/* big sparkle */}
      <path d="M12 2 14.4 8.8 22 11.9 14.4 15.2 12 22 9.6 15.2 2 11.9 9.6 8.8 12 2Z" />
      {/* small sparkle */}
      <path d="M18 3 19.3 6.4 23 7.8 19.3 9.1 18 12.5 16.7 9.1 13 7.8 16.7 6.4 18 3Z" />
      {/* tiny sparkle */}
      <path d="M6 6 6.9 8.3 9.3 9.2 6.9 10.1 6 12.4 5.1 10.1 2.7 9.2 5.1 8.3 6 6Z" />
    </svg>

  );
};




export const MindIcon = ({ size = 24, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* left brain */}
      <path d="M9 3c-1.5 0-3 .7-3 2.5S7.5 8 9 8v8c-1.5 0-3 .7-3 2.5S7.5 21 9 21" />
      {/* right brain */}
      <path d="M15 3c1.5 0 3 .7 3 2.5S16.5 8 15 8v8c1.5 0 3 .7 3 2.5S16.5 21 15 21" />
      {/* connections */}
      <path d="M9 8h6M9 16h6" />
    </svg>
  );
};





export const BrainIcon = ({ isActive }) => {
  return (
    <svg
      className="w-5 h-5 text-gray-800"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={isActive ? "#8b5cf6" : "currentColor"} // Purple when active
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 18.5A2.493 2.493 0 0 1 7.51 20H7.5a2.468 2.468 0 0 1-2.4-3.154 2.98 2.98 0 0 1-.85-5.274 2.468 2.468 0 0 1 .92-3.182 2.477 2.477 0 0 1 1.876-3.344 2.5 2.5 0 0 1 3.41-1.856A2.5 2.5 0 0 1 12 5.5m0 13v-13m0 13a2.493 2.493 0 0 0 4.49 1.5h.01a2.468 2.468 0 0 0 2.403-3.154 2.98 2.98 0 0 0 .847-5.274 2.468 2.468 0 0 0-.921-3.182 2.477 2.477 0 0 0-1.875-3.344A2.5 2.5 0 0 0 14.5 3 2.5 2.5 0 0 0 12 5.5m-8 5a2.5 2.5 0 0 1 3.48-2.3m-.28 8.551a3 3 0 0 1-2.953-5.185M20 10.5a2.5 2.5 0 0 0-3.481-2.3m.28 8.551a3 3 0 0 0 2.954-5.185"
      />
    </svg>
  );
};

export const Pallete = ({ isActive }) => {
  return (
    <svg
      className="w-5 h-5 text-gray-800"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={isActive ? "#ec4899" : "currentColor"} // Pink when active
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 7h.01m3.486 1.513h.01m-6.978 0h.01M6.99 12H7m9 4h2.706a1.957 1.957 0 0 0 1.883-1.325A9 9 0 1 0 3.043 12.89 9.1 9.1 0 0 0 8.2 20.1a8.62 8.62 0 0 0 3.769.9 2.013 2.013 0 0 0 2.03-2v-.857A2.036 2.036 0 0 1 16 16Z"
      />
    </svg>
  );
};

export const PenIcon = ({ isActive }) => {
  return (
    <svg
      className="w-5 h-5 text-gray-800"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={isActive ? "#10b981" : "currentColor"} // Green when active
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
      />
    </svg>
  );
};

export const DragAndDropIcon = () => {
  return (
    <svg
      className="w-8 h-8 mb-4 text-gray-800 dark:text-gray-400"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
      />
    </svg>
  );
};

export const CrossIcon = ({ isHovered }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 122.88 122.88"
      fill={isHovered ? "#ef4444" : "currentColor"} // Red when hovered
    >
      <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 
      c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 
      c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 
      c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313z" />
    </svg>
  );
};

export const RightIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 122.881 89.842"
      fill={isActive ? "#10b981" : "currentColor"} // Green when active (success)
    >
      <path d="M1.232,55.541c-1.533-1.388-1.652-3.756-0.265-5.289c1.388-1.534,3.756-1.652,5.29-0.265l34.053,30.878l76.099-79.699 
        c1.429-1.501,3.804-1.561,5.305-0.132c1.502,1.428,1.561,3.803,0.133,5.305L43.223,88.683l-0.005-0.005 
        c-1.396,1.468-3.716,1.563-5.227,0.196L1.232,55.541z" />
    </svg>
  );
};

export const CropIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 122.88 117.52"
      fill={isActive ? "#06b6d4" : "currentColor"} // Cyan when active
    >
      <path d="M74.01,0v11.98H19.13c-3.93,0.01-7.14,3.22-7.15,7.15v17.74H0V19.13c0-1.07,0.09-2.09,0.26-3.14 
        c0.91-5.37,3.99-10,8.56-12.96c3.13-2,6.6-3.01,10.31-3.03H74.01z M106.86,101.52v16H94.87v-16H79.6V89.53h15.27V69.72h11.98
        v19.81h16.03v11.98H106.86z M0,48.85h11.98v33.53c0.01,2.69,1.52,5.12,3.9,6.36L10.4,99.4c-3.97-2.06-7.06-5.36-8.84-9.46
        C0.52,87.51,0.01,85.02,0,82.39V48.85z M24.89,101.52V89.53h42.73v11.98H24.89z M106.85,57.74H94.87V19.13
        c-0.01-3.93-3.22-7.14-7.15-7.15h-1.73V0h1.73c1.07,0,2.09,0.09,3.14,0.26c5.37,0.91,10,3.99,12.96,8.56
        c2,3.13,3.01,6.6,3.03,10.31V57.74z" />
    </svg>
  );
};

export const PlusIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 122.881 122.88"
      fill={isActive ? "#10b981" : "currentColor"} // Green when active
    >
      <path d="M56.573,4.868c0-0.655,0.132-1.283,0.37-1.859c0.249-0.6,0.61-1.137,1.056-1.583C58.879,0.545,60.097,0,61.44,0 
      c0.658,0,1.287,0.132,1.863,0.371c0.012,0.005,0.023,0.011,0.037,0.017c0.584,0.248,1.107,0.603,1.543,1.039
      c0.881,0.88,1.426,2.098,1.426,3.442c0,0.03-0.002,0.06-0.006,0.089v51.62l51.619,0c0.029-0.003,0.061-0.006,0.09-0.006 
      c0.656,0,1.285,0.132,1.861,0.371c0.014,0.005,0.025,0.011,0.037,0.017c0.584,0.248,1.107,0.603,1.543,1.039
      c0.881,0.88,1.428,2.098,1.428,3.441c0,0.654-0.133,1.283-0.371,1.859c-0.248,0.6-0.609,1.137-1.057,1.583
      c-0.445,0.445-0.98,0.806-1.58,1.055v0.001c-0.576,0.238-1.205,0.37-1.861,0.37c-0.029,0-0.061-0.002-0.09-0.006l-51.619,0.001 
      v51.619c0.004,0.029,0.006,0.06,0.006,0.09c0,0.656-0.133,1.286-0.371,1.861c-0.006,0.014-0.012,0.025-0.018,0.037
      c-0.248,0.584-0.602,1.107-1.037,1.543c-0.883,0.882-2.1,1.427-3.443,1.427c-0.654,0-1.283-0.132-1.859-0.371
      c-0.6-0.248-1.137-0.609-1.583-1.056c-0.445-0.444-0.806-0.98-1.055-1.58h-0.001c-0.239-0.575-0.371-1.205-0.371-1.861 
      c0-0.03,0.002-0.061,0.006-0.09V66.303H4.958c-0.029,0.004-0.059,0.006-0.09,0.006c-0.654,0-1.283-0.132-1.859-0.371
      c-0.6-0.248-1.137-0.609-1.583-1.056c-0.445-0.445-0.806-0.98-1.055-1.58H0.371C0.132,62.726,0,62.097,0,61.44 
      c0-0.655,0.132-1.283,0.371-1.859c0.249-0.6,0.61-1.137,1.056-1.583c0.881-0.881,2.098-1.426,3.442-1.426 
      c0.031,0,0.061,0.002,0.09,0.006l51.62,0l0-51.62C56.575,4.928,56.573,4.898,56.573,4.868z"/>
    </svg>
  );
};

export const BookmarkIcon = ({ isBookmarked }) => {
  return (
    <svg
      className={`h-5 w-5 md:h-6 md:w-6 transition-all duration-300
                   text-yellow-500 dark:text-red-400" `}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      aria-hidden="true"
      role="img"
    >
      <path
        d="M 13 2 A 1.0001 1.0001 0 0 0 12 3 L 12 47 
           A 1.0001 1.0001 0 0 0 13.503906 47.863281 
           L 25 41.158203 L 36.496094 47.863281 
           A 1.0001 1.0001 0 0 0 38 47 L 38 3 
           A 1.0001 1.0001 0 0 0 37 2 L 13 2 z 
           M 14 4 L 36 4 L 36 45.259766 
           L 25.503906 39.136719 
           A 1.0001 1.0001 0 0 0 24.496094 39.136719 
           L 14 45.259766 L 14 4 z"
        fill={isBookmarked ? "#5c1818" : "none"}
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
};








export const DynamicNumberSVG = ({ value, size = 8 }) => {
  return (
    <div
      className={`
        loader border-r-2 rounded-full border-yellow-500 bg-yellow-300 
        aspect-square w-${size} text-md font-bold flex justify-center 
        items-center text-yellow-900 
      `}
    >
      {value > 1000 ? "∞" : value}
    </div>
  );
};


export const AiShowIcon = (props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 121.28"
    className={props.className}
    style={props.style}
  >
    <defs>
      {/* Neon gradient */}
      <linearGradient id="techGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#00f5ff" />     {/* Cyan */}
        <stop offset="50%" stopColor="#7c3aed" />   {/* Purple */}
        <stop offset="100%" stopColor="#ff0080" />  {/* Neon Pink */}
      </linearGradient>
      {/* Glow filter */}
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glow)">
      <path
        d="M98.42,98.8c-0.25-0.61-0.39-1.28-0.39-1.98s0.14-1.37,0.39-1.98c0.26-0.61,0.63-1.17,1.09-1.63l0.03-0.04 c0.26-0.26,0.56-0.51,0.88-0.7c0.17-0.11,0.35-0.21,0.55-0.3v-8.22h-8.51c-0.26,1.8-1.12,3.42-2.36,4.67 c-1.55,1.55-3.7,2.51-6.07,2.51H78.9v22.42h15.05c0.08-0.13,0.16-0.26,0.25-0.39c0.18-0.26,0.38-0.5,0.6-0.72 c0.47-0.47,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.69,0,1.37,0.14,1.98,0.39c0.64,0.26,1.2,0.65,1.68,1.12 c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.69-0.14,1.35-0.39,1.98c-0.26,0.64-0.65,1.21-1.12,1.68 s-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98,0.39c-0.68,0-1.33-0.13-1.94-0.38l-0.04-0.01c-0.64-0.26-1.2-0.65-1.68-1.12 c-0.29-0.29-0.55-0.63-0.77-0.98c-0.12-0.2-0.23-0.42-0.32-0.63H76.6c-0.64,0-1.21-0.26-1.63-0.68c-0.43-0.43-0.69-1-0.69-1.64l0,0 V91.13H63.08v20.34c0.17,0.09,0.34,0.18,0.51,0.29c0.31,0.19,0.6,0.43,0.85,0.68c0.48,0.48,0.86,1.04,1.12,1.68 c0.25,0.61,0.39,1.28,0.39,1.98c0,0.68-0.13,1.33-0.38,1.94l-0.01,0.04c-0.26,0.64-0.65,1.2-1.12,1.68 c-0.47,0.47-1.04,0.86-1.68,1.12c-0.61,0.25-1.28-0.39-1.98-0.39c-0.69,0-1.36-0.14-1.98-0.39c-0.64-0.26-1.21-0.65-1.68-1.12 c-0.47-0.47-0.86-1.04-1.12-1.68c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.68,0.13-1.33,0.38-1.94l0.01-0.04 c0.26-0.64,0.65-1.2,1.12-1.68c0.25-0.25,0.52-0.47,0.82-0.66l0.04-0.03c0.16-0.09,0.33-0.18,0.5-0.27l0,0V91.13H43.54v10.54 c0,0.64-0.26,1.21-0.68,1.63s-0.99,0.68-1.63,0.68H30.63c-0.08,0.16-0.17,0.31-0.27,0.47c-0.18,0.27-0.39,0.53-0.63,0.77 l-0.04,0.04c-0.47,0.47-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98,0.39c-0.68,0-1.33-0.13-1.94-0.38l-0.04-0.01 c-0.64-0.26-1.2-0.65-1.68-1.12c-0.47-0.47-0.86-1.04-1.12-1.68c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.69,0.14-1.36,0.39-1.98 c0.26-0.64,0.65-1.21,1.12-1.68c0.49-0.46,1.07-0.85,1.71-1.11l0,0c0.61-0.25,1.28-0.39,1.98-0.39c0.7,0,1.37,0.14,1.98,0.39 c0.61,0.26,1.17,0.63,1.63,1.1l0.04,0.03c0.26,0.26,0.51,0.56,0.7,0.88c0.1,0.17,0.21,0.35,0.3,0.55h8.22v-8.45 c-1.63-0.36-3.09-1.18-4.22-2.31c-1.51-1.51-2.44-3.57-2.44-5.83v-5.49H7.73v15.05c0.13,0.08,0.26,0.16,0.39,0.25 c0.26,0.18,0.49,0.38,0.72,0.6c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.69-0.14,1.37-0.39,1.98 c-0.26,0.64-0.65,1.2-1.12,1.68c-0.47,0.47-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98,0.39c-0.69,0-1.35-0.14-1.98-0.39 c-0.64-0.26-1.21-0.65-1.68-1.12c-0.47-0.47-0.86-1.04-1.12-1.68C0.14,98.22,0,97.55,0,96.85c0-0.68,0.13-1.33,0.38-1.94l0.01-0.04 c0.26-0.64,0.65-1.2,1.12-1.68c0.29-0.29,0.63-0.55,0.98-0.77c0.19-0.12,0.42-0.23,0.63-0.32V75c0-0.64,0.26-1.21,0.68-1.63 c0.43-0.43,1-0.69,1.64-0.69l0,0h26.83v-11.2H9.81c-0.09,0.17-0.18,0.34-0.29,0.51c-0.19,0.31-0.43,0.6-0.68,0.85 c-0.48,0.48-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98,0.39c-0.68,0-1.33-0.13-1.94-0.38l-0.04-0.01 c-0.64-0.26-1.2-0.65-1.68-1.12c-0.47-0.47-0.86-1.04-1.12-1.68c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.69,0.14-1.36,0.39-1.98 c0.26-0.64,0.65-1.21,1.12-1.68s1.04-0.86,1.68-1.12C3.82,54.14,4.48,54,5.19,54c0.68,0,1.33,0.13,1.94,0.38l0.04,0.01 c0.64,0.26,1.2,0.65,1.68,1.12c0.25,0.25,0.47,0.52,0.67,0.82l0.03,0.04c0.09,0.16,0.18,0.33,0.27,0.5l0,0h22.45V42.96 c0-0.34,0.02-0.68,0.06-1.02H19.61c-0.64,0-1.21-0.26-1.63-0.68c-0.42-0.42-0.68-0.99-0.68-1.63V29.03 c-0.16-0.08-0.31-0.17-0.47-0.27c-0.27-0.18-0.53-0.39-0.77-0.63l-0.04-0.04c-0.47-0.47-0.86-1.04-1.12-1.68 c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.68,0.13-1.33,0.38-1.94l0.01-0.04c0.26-0.64,0.65-1.2,1.12-1.68 c0.47-0.47,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.69,0,1.36,0.14,1.98,0.39c0.64,0.26,1.21,0.65,1.68,1.12 c0.46,0.49,0.85,1.07,1.11,1.71l0,0c0.25,0.61,0.39,1.28,0.39,1.98c0,0.7-0.14,1.37-0.39,1.98c-0.26,0.61-0.63,1.17-1.09,1.63 l-0.03,0.04c-0.26,0.26-0.56,0.51-0.89,0.7c-0.17,0.1-0.35,0.21-0.55,0.3v8.22h12.55v0.06c0.08-0.09,0.17-0.18,0.25-0.26 c1.55-1.55,3.7-2.51,6.07-2.51h4.81V7.73H30.54c-0.08,0.13-0.16,0.26-0.25,0.39c-0.18,0.26-0.38,0.49-0.6,0.72 c-0.47,0.47-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98-0.39c-0.69,0-1.37-0.14-1.98-0.39c-0.64-0.26-1.2-0.65-1.68-1.12 c-0.47-0.47-0.86-1.04-1.12-1.68C21,6.54,20.86,5.88,20.86,5.17c0-0.69,0.14-1.35,0.39-1.98c0.26-0.64,0.65-1.21,1.12-1.68 c0.47-0.47,1.04-0.86,1.68-1.12C24.66,0.14,25.33,0,26.03,0c0.68,0,1.33,0.13,1.94,0.38l0.04,0.01c0.64,0.26,1.2,0.65,1.68,1.12 c0.29,0.29,0.55,0.63,0.77,0.98c0.12,0.19,0.23,0.42,0.33,0.63h17.09c0.64,0,1.21,0.26,1.63,0.68c0.43,0.43,0.69,1,0.69,1.64l0,0 v29.18h11.2V9.81c-0.17-0.09-0.34-0.18-0.51-0.29c-0.31-0.19-0.6-0.43-0.85-0.68c-0.48-0.48-0.86-1.04-1.12-1.68 c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.68,0.13-1.33,0.38-1.94l0.01-0.04c0.26-0.64,0.65-1.2,1.12-1.68 c0.47-0.47,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.69,0,1.36,0.14,1.98,0.39c0.64,0.26,1.21,0.65,1.68,1.12 c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.68-0.13,1.33-0.38,1.94l-0.01,0.04 c-0.26,0.64-0.65,1.2-1.12,1.68c-0.25,0.25-0.52,0.47-0.82,0.67l-0.04,0.03c-0.09,0.16-0.18,0.33-0.27,0.5l0,0v24.8h14.93v-15 c0-0.64,0.26-1.21,0.68-1.63c0.42-0.42,0.99-0.68,1.63-0.68h10.61c0.08-0.16,0.17-0.31,0.27-0.47c0.18-0.27,0.39-0.53,0.63-0.77 l0.04-0.04c0.47-0.47,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.68,0,1.33,0.13,1.94,0.38l0.04,0.01 c0.64,0.26,1.2,0.65,1.68,1.12c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.69-0.14,1.36-0.39,1.98 c-0.26,0.64-0.65,1.21-1.12,1.68c-0.5,0.46-1.07,0.85-1.71,1.11l0,0c-0.61,0.25-1.28,0.39-1.98,0.39s-1.37-0.14-1.98-0.39 c-0.61-0.26-1.17-0.63-1.63-1.09l-0.04-0.03c-0.26-0.26-0.51-0.56-0.7-0.88c-0.11-0.17-0.21-0.35-0.3-0.55h-8.22v12.84 c1.77,0.31,3.35,1.17,4.56,2.38c1.51,1.51,2.44,3.57,2.44,5.83v1.03h22.6V28.93c-0.13-0.08-0.26-0.16-0.39-0.25 c-0.26-0.18-0.49-0.38-0.71-0.6c-0.47-0.47-0.86-1.04-1.12-1.68c-0.25-0.61-0.39-1.28-0.39-1.98c0-0.69,0.14-1.37,0.39-1.98 c0.26-0.64,0.65-1.2,1.12-1.68c0.47-0.47,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.69,0,1.36,0.14,1.98,0.39 c0.64,0.26,1.21,0.65,1.68,1.12c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.68-0.13,1.33-0.38,1.94 l-0.01,0.04c-0.26,0.64-0.65,1.2-1.12,1.68c-0.29,0.29-0.63,0.55-0.98,0.77c-0.2,0.12-0.42,0.23-0.63,0.33v17.09 c0,0.64-0.26,1.21-0.68,1.63c-0.43,0.43-1,0.69-1.64,0.69l0,0H92.55v11.2h20.52c0.09-0.17,0.18-0.34,0.29-0.51 c0.2-0.31,0.43-0.6,0.68-0.85c0.48-0.48,1.04-0.86,1.68-1.12c0.61-0.25,1.28-0.39,1.98-0.39c0.68,0,1.33,0.13,1.94,0.38l0.04,0.01 c0.64,0.26,1.2,0.65,1.68,1.12c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.69-0.14,1.36-0.39,1.98 c-0.26,0.64-0.65,1.21-1.12,1.68s-1.04,0.86-1.68,1.12c-0.61,0.25-1.28,0.39-1.98,0.39c-0.68,0-1.33-0.13-1.94-0.38l-0.04-0.01 c-0.64-0.26-1.2-0.65-1.68-1.12c-0.25-0.25-0.47-0.52-0.67-0.82l-0.03-0.04c-0.09-0.16-0.18-0.33-0.27-0.5l0,0H92.55v14.93h10.72 c0.64,0,1.21,0.26,1.63,0.68c0.42,0.42,0.68,0.99,0.68,1.63v10.61c0.16,0.08,0.31,0.17,0.47,0.28c0.27,0.18,0.53,0.39,0.77,0.63 l0.04,0.04c0.47,0.47,0.86,1.04,1.12,1.68c0.25,0.61,0.39,1.28,0.39,1.98c0,0.68-0.13,1.33-0.38,1.94l-0.01,0.04 c-0.26,0.64-0.65,1.2-1.12,1.68c-0.47,0.47-1.04-0.86-1.68-1.12c-0.61-0.25-1.28-0.39-1.98-0.39c-0.69,0-1.36-0.14-1.98-0.39 c-0.64-0.26-1.21-0.65-1.68-1.12C99.08,100.02,98.68,99.44,98.42,98.8L98.42,98.8L98.42,98.8z M53.49,52.14h17.84 c1.39,0,2.52,1.13,2.52,2.52v16.43c0,1.39-1.13,2.52-2.52,2.52H53.49c-1.39,0-2.52-1.13-2.52-2.52V54.66 C50.97,53.27,52.1,52.14,53.49,52.14L53.49,52.14z M84.04,39.08H40.77c-0.99,0-1.9,0.41-2.56,1.08c-0.71,0.71-1.15,1.7-1.15,2.8 v39.83c0,1.1,0.44,2.09,1.15,2.8c0.67,0.67,1.57,1.08,2.56,1.08h43.27c0.99,0,1.9-0.41,2.56-1.08c0.71-0.71,1.15-1.7,1.15-2.8 V42.96c0-1.1-0.44-2.09-1.15-2.8C85.94,39.49,85.03,39.08,84.04,39.08L84.04,39.08z"
        fill="url(#techGradient)"
      />
    </g>
  </svg>
);


export const PostLikeIcon = ({ isLiked, size = 36 }) => {
  return (
    <svg
      key={isLiked}
      viewBox="0 0 256 256"
      width={size}
      height={size}
      className={`inline-block rounded-full p-1 transition-transform duration-200 block animate-pop ${isLiked ? "text-[#ff5353]" : "text-black dark:text-gray-200"}`}
      aria-hidden={false}
      role="img"
    >
      <rect fill="none" height="256" width="256"></rect>
      <path
        d="M224.6,51.9a59.5,59.5,0,0,0-43-19.9,60.5,60.5,0,0,0-44,17.6L128,59.1l-7.5-7.4C97.2,28.3,59.2,26.3,35.9,47.4a59.9,59.9,0,0,0-2.3,87l83.1,83.1a15.9,15.9,0,0,0,22.6,0l81-81C243.7,113.2,245.6,75.2,224.6,51.9Z"
        strokeWidth={15}
        stroke="currentColor"
        // When liked, apply the fill color; otherwise keep it none
        className={isLiked ? "heart-fill" : "heart-unfilled"}
        fill={isLiked ? "#ff5353" : "none"}
      ></path>
    </svg>
  )
}


export const ShareIcon = ({ h = 24, w = 24 }) => {
  return (
    <svg height={h} width={w} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1024 1024" className="icon">

      <path fill="currentColor" stroke="currentColor" strokeWidth={4} d="M767.99994 585.142857q75.995429 0 129.462857 53.394286t53.394286 129.462857-53.394286 129.462857-129.462857 53.394286-129.462857-53.394286-53.394286-129.462857q0-6.875429 1.170286-19.456l-205.677714-102.838857q-52.589714 49.152-124.562286 49.152-75.995429 0-129.462857-53.394286t-53.394286-129.462857 53.394286-129.462857 129.462857-53.394286q71.972571 0 124.562286 49.152l205.677714-102.838857q-1.170286-12.580571-1.170286-19.456 0-75.995429 53.394286-129.462857t129.462857-53.394286 129.462857 53.394286 53.394286 129.462857-53.394286 129.462857-129.462857 53.394286q-71.972571 0-124.562286-49.152l-205.677714 102.838857q1.170286 12.580571 1.170286 19.456t-1.170286 19.456l205.677714 102.838857q52.589714-49.152 124.562286-49.152z"></path>
    </svg>
  )
}

export const FaceBookIcon = () => {
  return (
    <svg
      viewBox="0 0 320 512"
      height="1.2em"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      ></path>
    </svg>
  )
};

export const TwitterIcon = () => {
  return (
    <svg
      height="1.8em"
      fill="currentColor"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className="twitter"
    >
      <path
        d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"
      ></path>
    </svg>
  )
}

export const InstaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1.2em"
      fill="currentColor"
      className="bi bi-instagram"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
      ></path>
    </svg>
  )
}


export const DiscordIcon = () => {
  return (
    <svg height="20px" width="20px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className="discord"><path d="M40,12c0,0-4.585-3.588-10-4l-0.488,0.976C34.408,10.174,36.654,11.891,39,14c-4.045-2.065-8.039-4-15-4s-10.955,1.935-15,4c2.346-2.109,5.018-4.015,9.488-5.024L18,8c-5.681,0.537-10,4-10,4s-5.121,7.425-6,22c5.162,5.953,13,6,13,6l1.639-2.185C13.857,36.848,10.715,35.121,8,32c3.238,2.45,8.125,5,16,5s12.762-2.55,16-5c-2.715,3.121-5.857,4.848-8.639,5.815L33,40c0,0,7.838-0.047,13-6C45.121,19.425,40,12,40,12z M17.5,30c-1.933,0-3.5-1.791-3.5-4c0-2.209,1.567-4,3.5-4s3.5,1.791,3.5,4C21,28.209,19.433,30,17.5,30z M30.5,30c-1.933,0-3.5-1.791-3.5-4c0-2.209,1.567-4,3.5-4s3.5,1.791,3.5,4C34,28.209,32.433,30,30.5,30z" fill="#5865F2"></path></svg>
  )
}

export const WhatsAppIcon = () => {
  return (
    <svg
      className="whatsapp"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="20"
      width="20"
    >
      <path
        d="M19.001 4.908A9.817 9.817 0 0 0 11.992 2C6.534 2 2.085 6.448 2.08 11.908c0 1.748.458 3.45 1.321 4.956L2 22l5.255-1.377a9.916 9.916 0 0 0 4.737 1.206h.005c5.46 0 9.908-4.448 9.913-9.913A9.872 9.872 0 0 0 19 4.908h.001ZM11.992 20.15A8.216 8.216 0 0 1 7.797 19l-.3-.18-3.117.818.833-3.041-.196-.314a8.2 8.2 0 0 1-1.258-4.381c0-4.533 3.696-8.23 8.239-8.23a8.2 8.2 0 0 1 5.825 2.413 8.196 8.196 0 0 1 2.41 5.825c-.006 4.55-3.702 8.24-8.24 8.24Zm4.52-6.167c-.247-.124-1.463-.723-1.692-.808-.228-.08-.394-.123-.556.124-.166.246-.641.808-.784.969-.143.166-.29.185-.537.062-.247-.125-1.045-.385-1.99-1.23-.738-.657-1.232-1.47-1.38-1.716-.142-.247-.013-.38.11-.504.11-.11.247-.29.37-.432.126-.143.167-.248.248-.413.082-.167.043-.31-.018-.433-.063-.124-.557-1.345-.765-1.838-.2-.486-.404-.419-.557-.425-.142-.009-.309-.009-.475-.009a.911.911 0 0 0-.661.31c-.228.247-.864.845-.864 2.067 0 1.22.888 2.395 1.013 2.56.122.167 1.742 2.666 4.229 3.74.587.257 1.05.408 1.41.523.595.19 1.13.162 1.558.1.475-.072 1.464-.6 1.673-1.178.205-.58.205-1.075.142-1.18-.061-.104-.227-.165-.475-.29Z"
        stroke="currentColor"></path>
    </svg>
  )
}

export const LinkediIcon = () => {
  return (
    <svg viewBox="0 0 448 512" height={20} width={20} className="socialSvg linkdinSvg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" fill="#0077B5"></path></svg>
  )
}

export const RedditIcon = () => {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="white"
      height="1.6em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.8-97 156.6-213.2 156.6S45.5 410.1 43 323.4C17.6 311.5 0 285.7 0 255.7c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.7 15.6c34-21.1 76.8-34.4 123.7-36.4l0-.3c0-44.3 33.7-80.9 76.8-85.5C325.8 50.2 347.2 32 373 32c29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3zM157.5 255.3c-20.9 0-38.9 20.8-40.2 47.9s17.1 38.1 38 38.1s36.6-9.8 37.8-36.9s-14.7-49.1-35.7-49.1zM395 303.1c-1.2-27.1-19.2-47.9-40.2-47.9s-36.9 22-35.7 49.1c1.2 27.1 16.9 36.9 37.8 36.9s39.3-11 38-38.1zm-60.1 70.8c1.5-3.6-1-7.7-4.9-8.1c-23-2.3-47.9-3.6-73.8-3.6s-50.8 1.3-73.8 3.6c-3.9 .4-6.4 4.5-4.9 8.1c12.9 30.8 43.3 52.4 78.7 52.4s65.8-21.6 78.7-52.4z" fill="#FF4500"
      ></path>
    </svg>
  )
}



export const FounderBadge = ({ width = 40, height = 40 }) => {
  return (
    <svg viewBox="0 0 300 380" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="goldMetal" cx="50%" cy="40%">
          <stop offset="0%" style={{ stopColor: '#FFF9E6', stopOpacity: 1 }} />
          <stop offset="30%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
          <stop offset="60%" style={{ stopColor: '#DAA520', stopOpacity: 1 }} />
          <stop offset="85%" style={{ stopColor: '#B8860B', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#8B6914', stopOpacity: 1 }} />
        </radialGradient>

        <radialGradient id="scallop" cx="50%" cy="50%">
          <stop offset="0%" style={{ stopColor: '#FFE87C', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#F4C430', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#B8860B', stopOpacity: 1 }} />
        </radialGradient>

        <radialGradient id="centerGold" cx="45%" cy="35%">
          <stop offset="0%" style={{ stopColor: '#FFFACD', stopOpacity: 1 }} />
          <stop offset="40%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
          <stop offset="70%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#CC8400', stopOpacity: 1 }} />
        </radialGradient>

        <linearGradient id="ribbonRed" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#FF6B6B', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#EE5A5A', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#DC143C', stopOpacity: 1 }} />
        </linearGradient>

        <linearGradient id="ribbonHighlight" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#FF8888', stopOpacity: 0.8 }} />
          <stop offset="50%" style={{ stopColor: '#FF6B6B', stopOpacity: 0.3 }} />
          <stop offset="100%" style={{ stopColor: '#EE5A5A', stopOpacity: 0 }} />
        </linearGradient>

        <linearGradient id="starGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#FF8C00', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#CC6600', stopOpacity: 1 }} />
        </linearGradient>

        <filter id="shadow">
          <feGaussianBlur in="SourceAlpha" stdDeviation="8" />
          <feOffset dx="0" dy="8" result="offsetblur" />
          <feFlood floodColor="#000000" floodOpacity="0.3" />
          <feComposite in2="offsetblur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <filter id="glow">
          <feGaussianBlur stdDeviation="4" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Left Ribbon */}
      <g filter="url(#shadow)">
        <path d="M 120 200 Q 90 250, 80 320 Q 80 340, 70 360 L 70 380 Q 85 365, 100 360 Q 110 355, 115 340 Q 120 310, 140 260 Z"
          fill="url(#ribbonRed)" />
        <path d="M 120 200 Q 90 250, 80 320 Q 80 340, 70 360 L 75 360 Q 88 345, 95 330 Q 105 300, 130 250 Z"
          fill="url(#ribbonHighlight)"
          opacity="0.6" />
        <path d="M 125 210 Q 100 255, 88 315"
          fill="none"
          stroke="#B22222"
          strokeWidth="2"
          opacity="0.4" />
      </g>

      {/* Right Ribbon */}
      <g filter="url(#shadow)">
        <path d="M 180 200 Q 210 250, 220 320 Q 220 340, 230 360 L 230 380 Q 215 365, 200 360 Q 190 355, 185 340 Q 180 310, 160 260 Z"
          fill="url(#ribbonRed)" />
        <path d="M 180 200 Q 210 250, 220 320 Q 220 340, 230 360 L 225 360 Q 212 345, 205 330 Q 195 300, 170 250 Z"
          fill="url(#ribbonHighlight)"
          opacity="0.6" />
        <path d="M 175 210 Q 200 255, 212 315"
          fill="none"
          stroke="#B22222"
          strokeWidth="2"
          opacity="0.4" />
      </g>

      {/* Scalloped Edge Circle */}
      <g filter="url(#shadow)">
        <g>
          <circle cx="150" cy="70" r="20" fill="url(#scallop)" />
          <circle cx="185" cy="78" r="20" fill="url(#scallop)" />
          <circle cx="213" cy="100" r="20" fill="url(#scallop)" />
          <circle cx="228" cy="130" r="20" fill="url(#scallop)" />
          <circle cx="230" cy="165" r="20" fill="url(#scallop)" />
          <circle cx="218" cy="198" r="20" fill="url(#scallop)" />
          <circle cx="193" cy="223" r="20" fill="url(#scallop)" />
          <circle cx="162" cy="235" r="20" fill="url(#scallop)" />
          <circle cx="150" cy="240" r="20" fill="url(#scallop)" />
          <circle cx="138" cy="235" r="20" fill="url(#scallop)" />
          <circle cx="107" cy="223" r="20" fill="url(#scallop)" />
          <circle cx="82" cy="198" r="20" fill="url(#scallop)" />
          <circle cx="70" cy="165" r="20" fill="url(#scallop)" />
          <circle cx="72" cy="130" r="20" fill="url(#scallop)" />
          <circle cx="87" cy="100" r="20" fill="url(#scallop)" />
          <circle cx="115" cy="78" r="20" fill="url(#scallop)" />
        </g>

        <circle cx="150" cy="155" r="85" fill="url(#goldMetal)" />
      </g>

      {/* Inner Circle Ring */}
      <circle cx="150" cy="155" r="72" fill="none" stroke="url(#scallop)" strokeWidth="3" opacity="0.6" />

      {/* Center Light Circle */}
      <circle cx="150" cy="155" r="65" fill="url(#centerGold)" filter="url(#glow)" />

      {/* Inner Ring Detail */}
      <circle cx="150" cy="155" r="58" fill="none" stroke="#FFE87C" strokeWidth="2" opacity="0.7" />

      {/* Center Star */}
      <g filter="url(#glow)">
        <path d="M150 115 L160 140 L187 143 L166 162 L172 189 L150 175 L128 189 L134 162 L113 143 L140 140 Z"
          fill="url(#starGradient)" />
        <path d="M150 120 L158 140 L178 142 L162 157 L166 177 L150 166 L134 177 L138 157 L122 142 L142 140 Z"
          fill="#FF9933"
          opacity="0.5" />
      </g>

      {/* Subtle Edge Shadows on Badge */}
      <circle cx="150" cy="155" r="85" fill="none" stroke="#8B6914" strokeWidth="2" opacity="0.4" />

      {/* Ribbon Folds */}
      <g opacity="0.3">
        <path d="M 120 200 L 125 210 L 120 220" fill="none" stroke="#8B0000" strokeWidth="1.5" />
        <path d="M 180 200 L 175 210 L 180 220" fill="none" stroke="#8B0000" strokeWidth="1.5" />
      </g>
    </svg>
  );
};








